import React, { useCallback, useState } from 'react'
import { Grid, Range, TextInput, Typography } from 'gu-ui-kit'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { numberWithSpace } from 'utils/numberWithSpace'
import { onlyNumbers } from 'utils/normalize/onlyNumbers'
import styles from 'modules/PartnersProgram/subcomponents/RewardCalculator/subcomponents/Slider/Slider.module.scss'

export const Slider = ({
  min,
  max,
  step,
  value: defaultValue,
  className = '',
  onChange,
}) => {
  const [value, setValue] = useState(defaultValue)
  const { t } = useTranslation()
  const [textInputValue, setTextInputValue] = useState(defaultValue)

  const handleInputChange = useCallback((e) => {
    let value = +onlyNumbers(e.target.value)
    if (value <= max) {
      setValue(value)
      setTextInputValue(value)
    }
  }, [])

  const handleInputFocus = useCallback((e) => {
    setTextInputValue(e.target.value.replace(/[\s]/g, ''))
  }, [])

  const handleInputBlur = useCallback(
    (e) => {
      setTextInputValue(numberWithSpace(e.target.value))
      onChange(value)
    },
    [value],
  )

  const handleKeyDown = useCallback(
    (e) => e.key === 'Enter' && onChange(value),
    [value],
  )

  const handleChange = useCallback((value) => {
    setValue(value)
    onChange(value)
    setTextInputValue(numberWithSpace(value))
  }, [])

  return (
    <Grid
      direction={'column'}
      gap={8}
      className={clsx(styles['slider'], className)}
    >
      <TextInput
        type="text"
        fullWidth
        className={'margin-bottom-8'}
        value={+textInputValue === min ? '' : textInputValue}
        onChange={handleInputChange}
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
        onKeyDown={handleKeyDown}
        placeholder={t('reward_calculator::turnover')}
      />

      <Range
        min={min}
        max={max}
        value={value}
        step={step}
        onChange={handleChange}
        tooltipTemplate={(value) => numberWithSpace(value)}
      />

      <Grid
        justifyContent={'between'}
        wrap={false}
        alignItems={'center'}
        className={styles['slider__footer']}
      >
        <Typography
          component={'div'}
          color={'Interface-Seventh'}
          variant={'Forms-15'}
        >
          {min}
        </Typography>
        <Typography
          component={'div'}
          color={'Interface-Seventh'}
          variant={'Forms-15'}
        >
          <span
            dangerouslySetInnerHTML={{
              __html: t('reward_calculator::max_value', {
                value: numberWithSpace(max),
              }),
            }}
          />
        </Typography>
      </Grid>
    </Grid>
  )
}

Slider.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  value: PropTypes.number,
  className: PropTypes.string,
  onChange: PropTypes.func,
}
